<template>
  <v-container fluid class="pa-0 mb-10">
    <DxDataGrid :data-source="inventory" :remote-operations="true" :row-alternation-enabled="true" :show-borders="true"
      @content-ready="e => onContentReady(e)">

      <DxColumn data-field="ArticleNumber" data-type="string" :group-index="0" 
        :allow-sorting="false" /> <!-- group-cell-template="groupCellTemplate" -->
      <DxColumn data-field="ArticleDescription" data-type="string" :allow-grouping="false" :allow-sorting="false" />
      <DxColumn data-field="StoreName" data-type="string" :allow-grouping="false" :allow-sorting="false" />
      <DxColumn data-field="StoreLocation" data-type="string" :allow-grouping="false" :allow-sorting="false" />
      <DxColumn data-field="Available" data-type="string" :allow-grouping="false" :allow-sorting="true" />

      <DxGroupPanel :visible="true" />
      <DxSearchPanel :visible="false" :highlight-case-sensitive="true" />

      <DxGrouping :auto-expand-all="true" />

      <DxPager :allowed-page-sizes="pageSizes" :show-page-size-selector="true" />
      <DxPaging :page-size="pageSizes[0]" />

      <DxExport :enabled="true" />

      <!-- <DxScrolling
      mode="virtual"
      row-rendering-mode="virtual"
    />-->

    <!--
      <template #groupCellTemplate="{ data }">
        <v-row no-gutters>
          <v-col cols="auto" class="pr-10">
            {{ data.value }} {{ data.data.items[0].ArticleDescription }}
          </v-col>
          <v-col v-if="data.groupContinuedMessage">
            {{ data.groupContinuedMessage }}
          </v-col>
          <v-col v-if="data.groupContinuesMessage">
            {{ data.groupContinuesMessage }}
          </v-col>
        </v-row>
      </template>
-->
    </DxDataGrid>
    <!-- <pre>{{ inventory }}</pre> -->
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import {
  DxColumn,
  DxDataGrid,
  DxExport,
  DxGrouping,
  DxGroupPanel,
  //DxScrolling,
  DxPager,
  DxPaging,
  DxSearchPanel,
} from 'devextreme-vue/data-grid';
import CustomStore from 'devextreme/data/custom_store';

const store = new CustomStore({
  key: 'ArticleNumber',
  load(loadOptions) {
    let params = '?';
    [
      'skip',
      'take',
      'requireTotalCount',
      'requireGroupCount',
      'sort',
      'filter',
      'totalSummary',
      'group',
      'groupSummary',
    ].forEach((i) => {
      if (i in loadOptions && isNotEmpty(loadOptions[i])) {
        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
      }
    });

    //console.log(loadOptions)
    params = params.slice(0, -1);
    return clientAPI.methods.getInventory(params)
      .then((response) => response.data)
      .then((data) => ({
        data: data.data,
        totalCount: data.totalCount,
        //summary: data.summary,
        groupCount: data.groupCount,
      }))
      .catch((e) => {
        console.error(e)
        throw new Error('Data Loading Error');
      });
  },
});

function isNotEmpty(value) {
  return value !== undefined && value !== null && value !== '';
}

export default {
  name: 'InventoryPage',
  props: {},
  components: {
    DxDataGrid,
    DxExport,
    DxColumn,
    DxGrouping,
    DxGroupPanel,
    //DxScrolling,
    DxPager,
    DxPaging,
    DxSearchPanel,
  },
  mixins: [clientAPI],

  data() {
    return {
      loading: false,
      inventory: store,
      pageSizes: [25, 50, 100, 1000],
    };
  },

  mounted() {
    //this.getInventoryRequest(null, 100)
  },

  methods: {
    getInventoryRequest(search, itemsPerPage, page) {
      this.loading = true;
      clientAPI.methods.getInventory(search, itemsPerPage, page)
        .then(response => {
          this.inventory = response;
        })
        .finally(this.loading = false);
    },

    onContentReady(/*e*/) { },
  },

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped></style>